module.exports = __webpack_public_path__ + "static/img/solve7.75802ed.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/solve7.svg
// module id = 7Lv7
// module chunks = 0